import { APP_ID, ROLE_PERMISSIONS } from '../../constants';

const getClientsContactPermissionFallback = (permissionId, appId) => {
	if (Number(appId) !== APP_ID.CLIENTS) {
		return null;
	}

	switch (Number(permissionId)) {
		case ROLE_PERMISSIONS.VIEW_CONTACT_LIST_PAGE:
		case ROLE_PERMISSIONS.VIEW_CONTACT_DETAIL_PAGE:
			return ROLE_PERMISSIONS.CLIENTS_VIEW_CLIENTS;
		case ROLE_PERMISSIONS.ADD_EDIT_CONTACTS:
			return ROLE_PERMISSIONS.CLIENTS_MANAGE_CLIENTS;
		default:
			return null;
	}
};

export const roleHasPermission = ({ role, permissionId, appId }) => {
	const permissions = Array.isArray(role?.permissions)
		? role.permissions.map(value => Number(value)).filter(Number.isFinite)
		: [];
	const numericPermissionId = Number(permissionId);

	if (!Number.isFinite(numericPermissionId)) {
		return false;
	}

	if (permissions.includes(numericPermissionId)) {
		return true;
	}

	const fallbackPermissionId = getClientsContactPermissionFallback(numericPermissionId, appId);

	return Boolean(fallbackPermissionId && permissions.includes(fallbackPermissionId));
};
